

































import Vue from 'vue';

import BaseIcon from '../BaseIcon/BaseIcon.vue';

/**
 * A wrapper for icons that will be rendered inside of an Input
 *
 * If the the variant is 'button', the `design-system-react/components/button` component is used.
 * If not, the icon will be an instance of `design-system-react/components/utilities/utility-icon`.
 * Checkout out the appropriate component to see what props can be passed along via the `{...$attrs}` rest operator
 */
export default Vue.extend({
  components: {
    BaseIcon,
  },
  inheritAttrs: false,
  props: {
    /**
     * This is only needed if an input contains two icons, the Input component handles this prop for you.
     */
    position: {
      type: String,
      default: undefined,
      validator(val: string) {
        return ['left', 'right'].includes(val);
      },
    },
    /**
     * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
     */
    name: {
      type: String,
      default: undefined,
    },
    variant: {
      type: String,
      validator(val: string) {
        return ['base', 'button', 'combobox'].includes(val);
      },
      default: 'base',
    },
  },
});
